import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AdminNotificationService, OrderNotification } from '../../../services/admin-notification.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-notification-drawer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-drawer.component.html',
  styleUrls: ['./notification-drawer.component.scss']
})
export class NotificationDrawerComponent implements OnInit, OnDestroy {
  @Input() isOpen = false;
  @Output() closeDrawer = new EventEmitter<void>();

  notifications: OrderNotification[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private notificationService: AdminNotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.notificationService.notifications$
      .pipe(takeUntil(this.destroy$))
      .subscribe(notifications => {
        this.notifications = notifications;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onNotificationClick(notification: OrderNotification): void {
    // Mark as read
    this.notificationService.markAsRead(notification.id);
    
    // Close drawer
    this.closeDrawer.emit();
    
    // Navigate to order details
    this.router.navigate(['/admin/orders', notification.orderId]);
  }

  markAllAsRead(): void {
    this.notificationService.markAllAsRead();
  }

  deleteNotification(event: Event, notificationId: string): void {
    event.stopPropagation(); // Prevent triggering the click event
    this.notificationService.deleteNotification(notificationId);
  }

  clearAll(): void {
    this.notificationService.clearAll();
  }

  formatTime(date: Date): string {
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (minutes < 1) {
      return 'Just now';
    } else if (minutes < 60) {
      return `${minutes}m ago`;
    } else if (hours < 24) {
      return `${hours}h ago`;
    } else if (days < 7) {
      return `${days}d ago`;
    } else {
      return date.toLocaleDateString();
    }
  }

  formatDateTime(date: Date): string {
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getProductNames(notification: OrderNotification): string {
    if (notification.productNames.length === 0) {
      return 'Order';
    } else if (notification.productNames.length === 1) {
      return notification.productNames[0];
    } else if (notification.productNames.length === 2) {
      return notification.productNames.join(' and ');
    } else {
      return `${notification.productNames[0]} and ${notification.productNames.length - 1} more`;
    }
  }
}

